export default {
    init() {
        this.quickView();
        this.mainTableActionsToggle();
        this.maineditColumns();
        this.rowCheckamarkHover();
    },

    quickView() {
        const self = this;
        let quickView = $('.quick-view-box');
        let slickSettings = {
            slidesToShow: 1,
            dots: false,
            infinite: false,
            arrows: true,
            speed: 300,
            autoplay: false,
            slidesToScroll: 1,
            fade: true,
            // responsive: [
            //     {
            //         breakpoint: 1200,
            //         settings: {
            //             slidesToShow: 2,
            //         }
            //     }
            // ]
        };
        let slider = $('.quick-view-box--gallery--main-slider');
        let body = $('body');

        body.on('click', function (e) {
            if ($(e.target).hasClass('quick-view')) {
                e.preventDefault();

                quickView.fadeIn(300);
                slider.slick(slickSettings);
                self.fancyboxSettings();
                self.galleryNavigation();
            }
        });

        $('.quick-view-box--inner .close').on('click', function () {
            quickView.fadeOut(300);
            setTimeout(function () {
                slider.slick('unslick');
            }, 500);
        });

        body.on('mousedown', function (e) {
            if ($(e.target).hasClass('quick-view-box')) {
                quickView.fadeOut(300);
                setTimeout(function () {
                    slider.slick('unslick');
                }, 500);
            }
        });
    },

    mainTableActionsToggle() {
        let moreActionsBtn = $('.actions-more');

        moreActionsBtn.on('click', function (e) {
            e.preventDefault();

            let thisDrop = $(this).parent().find('.actions-drop');
            let drops = $('.actions-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.actions-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });

        let dropdowns = $('.actions-drop');

        $('body').on('click', function (e) {
            if (!moreActionsBtn.is(e.target) && moreActionsBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });
    },

    maineditColumns(){
        let moreActionsBtn = $('.edit-columns-btn');


        //$('.dropdown-toggle').dropdown();

        moreActionsBtn.on('click', function (e) {
            e.preventDefault();

            let thisDrop = $(this).parent().find('.edit-columns-drop');
            let drops = $('.actions-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.actions-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });

        let dropdowns = $('.edit-columns-drop');

        $('body').on('click', function (e) {
            if (!moreActionsBtn.is(e.target) && moreActionsBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });

    },

    rowCheckamarkHover(){
        $('.ch-hover .lots-item-checkbox').on('change', function(){
            let row =  $(this).closest('tr');
            if($(this).is(':checked')){
                row.addClass('ch-row-checked');
                if(row.hasClass('package-lot')){
                    let packageLink = row.data( "package" );
                    $('.package-inner[data-package-inner='+packageLink+']').addClass('ch-row-checked');
                }
            } else {
                row.removeClass('ch-row-checked');
                if(row.hasClass('package-lot')){
                    let packageLink = row.data( "package" );
                    $('.package-inner[data-package-inner='+packageLink+']').removeClass('ch-row-checked');
                }
            }
        });
    },
}